import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "rgba(162, 134, 201, 1)" },
    secondary: { main: "rgba(133, 186, 199, 1)" },
    background: {
      default: "linear-gradient(135deg, rgba(33, 36, 50, 1) 0%, rgba(31, 28, 47, 1) 50%, rgba(32, 19, 46, 1) 100%)",
      paper: "rgba(255, 255, 255, 0.05)",
    },
    // Role colors
    roles: {
      admin: "rgba(211, 100, 126, 1)",
      teamlead: "rgba(228, 165, 39, 1)",
      carecoordinator: "rgba(91, 158, 130, 1)",
    },
    // Status colors
    status: {
      success: "rgba(91, 158, 130, 1)",
      warning: "rgba(228, 165, 39, 1)",
      error: "rgba(211, 100, 126, 1)",
      info: "rgba(101, 169, 196, 1)",
    },
    // Performance indicators
    performance: {
      excellent: "rgba(91, 158, 130, 1)",
      good: "rgba(101, 169, 196, 1)",
      needsImprovement: "rgba(228, 165, 39, 1)",
      critical: "rgba(211, 100, 126, 1)",
    },
  },
  typography: {
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  // Custom gradients
  gradients: {
    excellent: 'linear-gradient(135deg, rgba(91, 158, 130, 1) 0%, rgba(56, 114, 90, 1) 100%)',
    warning: 'linear-gradient(135deg, rgba(228, 165, 39, 1) 0%, rgba(194, 134, 16, 1) 100%)',
    error: 'linear-gradient(135deg, rgba(211, 100, 126, 1) 0%, rgba(211, 100, 126, 1) 100%)',
    info: 'linear-gradient(90deg, rgba(101, 169, 196, 1) 0%, rgba(68, 117, 137, 1) 100%)',
    errorToWarning: 'linear-gradient(90deg, rgba(162, 134, 201, 1) 0%, rgba(107, 150, 161, 1) 100%)',
  },
  // Glassmy styles
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: "rgba(255, 255, 255, 0.03)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        },
      },
    },
  },
});

export default theme;